import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { getAllTestDataSets } from "./testLoadData";
import "./TestDataSelector.scss";

const TestDataSelector = ({ isEditMode = false }) => {
  const formContext = useFormContext();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDataSet, setSelectedDataSet] = useState(null);
  const testDataSets = getAllTestDataSets();

  if (isEditMode || !formContext) {
    return null;
  }

  const { reset } = formContext;

  const handleSelectDataSet = (dataSet) => {
    setSelectedDataSet(dataSet);
  };

  const handleLoadData = () => {
    if (!selectedDataSet) return;

    const data = { ...selectedDataSet.data };
    
    reset(data, {
      keepDefaultValues: false,
      keepDirty: false,
      keepErrors: false,
      keepIsSubmitted: false,
      keepTouched: false,
      keepIsValid: false,
      keepSubmitCount: false
    });
    
    setIsOpen(false);
    setSelectedDataSet(null);
  };

  const handleCancel = () => {
    setIsOpen(false);
    setSelectedDataSet(null);
  };

  return (
    <div className="test-data-selector">
      <button
        type="button"
        className="test-data-selector__trigger"
        onClick={() => setIsOpen(!isOpen)}
        title="Загрузить тестовые данные"
      >
        🧪 Test Data
      </button>

      {isOpen && (
        <div className="test-data-selector__modal">
          <div className="test-data-selector__modal-content">
            <div className="test-data-selector__header">
              <h3>Выберите тестовые данные</h3>
              <button
                type="button"
                className="test-data-selector__close"
                onClick={handleCancel}
              >
                ×
              </button>
            </div>

            <div className="test-data-selector__list">
              {testDataSets.map((dataSet) => (
                <div
                  key={dataSet.key}
                  className={`test-data-selector__item ${
                    selectedDataSet?.key === dataSet.key ? "selected" : ""
                  }`}
                  onClick={() => handleSelectDataSet(dataSet)}
                >
                  <div className="test-data-selector__item-name">
                    {dataSet.name}
                  </div>
                  <div className="test-data-selector__item-description">
                    {dataSet.description}
                  </div>
                </div>
              ))}
            </div>

            <div className="test-data-selector__actions">
              <button
                type="button"
                className="test-data-selector__btn test-data-selector__btn--cancel"
                onClick={handleCancel}
              >
                Отмена
              </button>
              <button
                type="button"
                className="test-data-selector__btn test-data-selector__btn--load"
                onClick={handleLoadData}
                disabled={!selectedDataSet}
              >
                Загрузить данные
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestDataSelector;
